import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TravelSheetModel } from '../travel-sheet/travel-sheet/travel-sheet.model';
import { AppAPIConfig } from './app-api-config';

@Injectable({
  providedIn: 'root'
})
export class TravelSheetService {
  appApi = new AppAPIConfig();
  httpOptions = {};
  httpOptionsForUpload = {};
  httpOptionsForDelete = {};
  httpOptionsForExportToExcel = {};
  travelSheetModel: TravelSheetModel;

  constructor(private http: HttpClient) {
    this.httpOptions = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('token'),
        'Content-Type': 'application/json',
      }),
    };

    this.httpOptionsForUpload = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('token'),
      }),
    };

    this.httpOptionsForExportToExcel = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('token'),
      }),
      responseType: 'blob'
    };
  }

  refreshHttpOptions() {
    this.httpOptions = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('token'),
        'Content-Type': 'application/json',
      }),
      // observe: 'response'
    };

    this.httpOptionsForDelete = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('token'),
        'Content-Type': 'application/json',
      }),
      body: {},
    };

    this.httpOptionsForUpload = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('token'),
      }),
    };

    this.httpOptionsForExportToExcel = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('token'),
      }),
      responseType: 'blob'
    };
  }

  saveTravelSheetDetails(formData, docType) {
    return this.http.post<TravelSheetModel>(
      this.appApi.travelSheetAPI + '?docType=' + docType,
      formData,
      this.httpOptionsForUpload
    )
  }

  updateTravelSheetDetails(formData, docType) {
    return this.http.put<TravelSheetModel>(
      this.appApi.travelSheetAPI + '?docType=' + docType,
      formData,
      this.httpOptionsForUpload
    )
  }

  deleteTravelSheetDocument(deletedId) {
    return this.http.delete<TravelSheetModel>(this.appApi.travelSheetAPI + '/document/' + deletedId, this.httpOptions);
  }

  getTravelSheetDetails(userId,fyId) {
    return this.http.get<TravelSheetModel>(this.appApi.travelSheetAPI + '/submitted/' + userId+'/'+fyId, this.httpOptions);
  }

  deleteTravelSheet(travelSheetId) {
    return this.http.delete<TravelSheetModel>(
      this.appApi.travelSheetAPI + '/' + travelSheetId,
      this.httpOptions
    );
  }

  getPendingTravelSheetDetails(userId) {
    return this.http.get<TravelSheetModel>(this.appApi.travelSheetAPI + '/pending/' + userId, this.httpOptions);
  }

  getAllSubmittedTravelSheets(branchId,roleId,dateId){
    return this.http.get<TravelSheetModel>(this.appApi.travelSheetAPI + '/submitted-Sheets?branchId='+branchId+'&role='+roleId+'&closingDateId='+dateId, this.httpOptions);
  }

  excelExportSubmittedTravelSheets(branchId,roleId,dateId){
    return this.http.get(this.appApi.submittedSheetsExportToExcelAPI + '?branchId='+branchId+'&role='+roleId+'&closingDateId='+dateId, { ...this.httpOptionsForExportToExcel });
  }

  getAllSubmittedTravelSheetDetails() {
    return this.http.get<TravelSheetModel>(this.appApi.travelSheetAPI + '/submitted', this.httpOptions);
  }

  getApprovedResendTravelSheetDetails(approverId, status, reason) {
    return this.http.put<TravelSheetModel>(this.appApi.travelSheetAPI + '/approve/' + approverId + '/' + status + '?reason=' + reason,
      {},
      this.httpOptions
    )
  }

  getUnApprovedSheetDetails() {
    return this.http.get<TravelSheetModel>(this.appApi.travelSheetAPI + '/unapproved', this.httpOptions);
  }

  checkSelectedDateLeave(date) {
    return this.http.get<TravelSheetModel>(this.appApi.travelSheetLeaveCheckAPI + '/check/' + date, this.httpOptions);
  }
}
